<base-support-modal
	[title]="title"
	[btnOkClass]="'btn-warning'"
	[btnOkLabel]="'Установить'"
	[isBtnOkActive]="isBtnOkActive"
	(onOk)="ok()"
>
	<div [formGroup]="form">
		<h5>
			Активный инвойс (recurrentProfile === "{{ recurrentProfile }}")
		</h5>
		
		<div class="form-group">
			<label>
				Дата списания
			</label>

			<datepicker
				formControlName="rebillStartDate"
				[(ngModel)]="rebillStartDate"
			></datepicker>
		</div>
		
		<div class="form-group">
			<label>
				Сумма списания({{userCurrency}})
			</label>

			<input
				type="number"
				[min]="0"
				formControlName="amount"
				[(ngModel)]="amount"
				[placeholder]="000.00"
				class="form-control"
			/>
		</div>		
	</div>
</base-support-modal>
